import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER, API_USER_EMAIL } from '@/api/endpoints';
import { USER_QUERY_KEY } from '@/api/queryKeys';
import type { UserInfoResponse } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export const useUpdateEmail = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateEmail, isPending } = useMutation({
    mutationFn: (emailAddress: string) =>
      apiClient.post(API_USER_EMAIL, { emailAddress }),
    onSuccess: async (_data, emailAddress) => {
      queryClient.setQueryData<UserInfoResponse>(USER_QUERY_KEY, (user) =>
        user ? { ...user, emailAddress } : user,
      );

      try {
        const freshUser = await apiClient
          .get<UserInfoResponse>(API_USER)
          .then(unwrapAxiosResponse);

        queryClient.setQueryData(USER_QUERY_KEY, freshUser);
      } catch (error) {
        logRequestError(ErrorMessage.ChangeEmail, error);
      }
    },
  });

  return { updateEmail, isPending };
};
